import React from 'react';

function HeroBlockLoading() {
  return <section className={`relative heroblock skeleton `} />;
}

export default HeroBlockLoading;
